export const di = {
  // TODO string "desktop-body" is hardcoded in other files, once migrated to vanilla-extract these should use this constant
  desktop: 'desktop-body',
  // handheld: 'handheld-body', in case we need this later
  ios: 'ios-body',
} as const;

export const OS = {
  ANDROID: 'android',
  IOS: 'ios',
  PC: 'pc',
};

export const PLATFORM = {
  PHONE: 'phone',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

export const FRAME = {
  IFRAME: 'iframe',
  POPUP: 'popup',
  FULL: 'full',
};

export const BROWSER = {
  CHROME: 'chrome',
  SAFARI: 'safari',
  EXPLORER: 'explorer',
  EDGE: 'edge',
  FIREFOX: 'firefox',
  OPERA: 'opera',
  UNKNOWN: 'unknown',
};

export const TYPE = {
  HTML: 'html',
  TABLET: 'tablet',
  SMARTPHONE: 'smartphone',
  MOBILE: 'mobile',
};

export const DEVICE = {
  OS,
  PLATFORM,
  FRAME,
  BROWSER,
  TYPE,
};

const desktopBodySelector = `body:is(.${di.desktop})` as const;
const handheldBodySelector = `body:not(.${di.desktop})` as const;

/**
   * device selector for targeting css to a specific type of device
   *
   * @example
   *
   * ```
   * const cssPerDeviceType = style({
   *   selectors: {
   *     [`${ds.desktopSelector} div.yellowColor &`]: {
   *       // css here will be applied only on desktop, on div having class="yellowColor"
   *       color: 'yellow',
   *     },
   *     [ds.desktop]: {
   *       // css here will be applied only on desktop
   *       color: 'blue',
   *     },
   *     [ds.handheld]: {
   *       // css here will be applied only on handheld
   *       color: 'red',
   *     },
   *     [ds.ios]: {
   *       // css here will be applied only on iOS
   *       color: 'white',
   *     },
   *   },
   * });
   * ```
   */
export const ds = {
  desktopSelector: desktopBodySelector,
  handheldSelector: handheldBodySelector,
  desktop: `${desktopBodySelector} &`,
  handheld: `${handheldBodySelector} &`,
  ios: `body:is(.${di.ios}) &`,
} as const;
